import { render } from "./PaymentMethodTabs.vue?vue&type=template&id=4b53a6f8"
import script from "./PaymentMethodTabs.vue?vue&type=script&lang=js"
export * from "./PaymentMethodTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__